<template>
  <div class="tab-icon-con" :class="'active' + activeIndex">
    <i
      class="iconfont"
      :class="[icon1, activeIndex == 0 ? 'active-icon' : '']"
      @click="onTab(0)"
    ></i>
    <i
      class="iconfont"
      :class="[icon2, activeIndex == 1 ? 'active-icon' : '']"
      @click="onTab(1)"
    ></i>
  </div>
</template>
<script>
export default {
  props: {
    icon1: {
      type: String,
      default: "icon-24gl-table",
    },
    icon2: {
      type: String,
      default: "icon-shujulaiyuan",
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    currentIndex: {
      handler(val) {
        console.log(val);
        this.activeIndex = val;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    onTab(index) {
      this.activeIndex = index;
      this.$emit("onTabIcon", index);
    },
    returnIndex(index) {
      this.activeIndex = index;
    },
  },
};
</script>
<style scoped>
.tab-icon-con {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: auto;
  height: 50px;
  padding: 3px 20px;
  background: #f5f5f5;
  border-radius: 25px;
  cursor: pointer;
}
.tab-icon-con i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 32px;
  height: 32px;
  font-size: 35px;
  color: #999999;
  z-index: 1;
}
.tab-icon-con .active-icon {
  color: #f9722c;
}
.tab-icon-con .icon-shujulaiyuan {
  font-size: 27px;
}
.tab-icon-con .icon-zuzhi {
  font-size: 30px;
}
.tab-icon-con .icon-guanxichaxunyoushangguanxi {
  font-size: 32px;
}
.tab-icon-con i + i {
  margin-left: 36px;
}
.tab-icon-con::before {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 66px;
  height: 44px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 22px;
  z-index: 0;
  transition: all 0.3s;
}
.tab-icon-con.active1::before {
  left: 69px;
}
@media (max-width: 1920px) {
  .tab-icon-con {
    height: 34px;
    padding: 2px 14px;
    border-radius: 17px;
  }
  .tab-icon-con i {
    width: 22px;
    height: 22px;
    font-size: 24px;
  }
  .tab-icon-con .icon-shujulaiyuan {
    font-size: 18px;
  }
  .tab-icon-con .icon-zuzhi {
    font-size: 20px;
  }
  .tab-icon-con .icon-guanxichaxunyoushangguanxi {
    font-size: 22px;
  }
  .tab-icon-con i + i {
    margin-left: 24px;
  }
  .tab-icon-con::before {
    top: 2px;
    left: 2px;
    width: 44px;
    height: 30px;
    border-radius: 15px;
  }
  .tab-icon-con.active1::before {
    left: 49px;
  }
}
</style>
